(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Fitment matrix
  // Row: [variant, market, year, battery, display, nomad_g1, scout_tall, scout_low, nomad_ii, nomad_iii, drifter_g1, drifter_ii]
  // Values: 1=fit  0=no_fit  2=unknown
  // ---------------------------------------------------------------------------
  var F = [
    ['Base','US',2021,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','US',2022,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','US',2023,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','US',2024,'YTZ7S','TFT',0,0,0,1,0,1,0],
    ['Base','US',2025,'YTZ7S','TFT',0,0,0,0,1,0,1],
    ['Base','US',2026,'YTZ7S','TFT',0,0,0,0,1,0,1],
    ['World Raid','US',2026,'YTZ10S','TFT',2,2,2,2,2,2,2],
    ['Base','EU',2019,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','EU',2020,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','EU',2021,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','EU',2022,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','EU',2023,'YTZ7S','TFT',0,0,0,1,0,1,0],
    ['Base','EU',2024,'YTZ7S','TFT',0,0,0,1,0,1,0],
    ['Base','EU',2025,'YTZ7S','TFT',0,0,0,0,1,0,1],
    ['Base Low','EU',2025,'YTZ7S','TFT',0,0,0,0,1,0,1],
    ['Rally Edition','EU',2023,'YTZ7S','TFT',0,0,0,1,0,1,0],
    ['Rally','EU',2025,'YTZ7S','TFT',0,0,0,0,1,0,1],
    ['Extreme','EU',2024,'YTZ7S','TFT',0,0,0,1,0,1,0],
    ['World Raid','EU',2022,'YTZ10S','TFT',1,0,0,0,0,1,0],
    ['World Raid','EU',2023,'YTZ10S','TFT',1,0,0,0,0,1,0],
    ['World Raid','EU',2024,'YTZ10S','TFT',1,0,0,0,0,1,0],
    ['World Raid','EU',2025,'YTZ10S','TFT',0,0,0,0,2,0,1],
    ['World Raid','EU',2026,'YTZ10S','TFT',0,0,0,0,2,0,1],
    ['World Rally','EU',2023,'YTZ10S','TFT',1,0,0,0,0,1,0],
    ['World Rally','EU',2024,'YTZ10S','TFT',1,0,0,0,0,1,0],
    ['Base','AU',2020,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','AU',2021,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','AU',2022,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','AU',2023,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','AU',2024,'YTZ7S','TFT',0,0,0,1,0,1,0],
    ['Base','AU',2025,'YTZ7S','TFT',0,0,0,0,1,0,1],
    ['World Raid','AU',2026,'YTZ7S','TFT',2,2,2,2,2,0,1],
    ['Base','JP',2020,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','JP',2021,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','JP',2022,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','JP',2023,'YTZ10S','LCD',1,1,1,0,0,1,0],
    ['Base','JP',2024,'YTZ7S','TFT',0,0,0,1,0,1,0],
    ['Base','JP',2025,'YTZ7S','TFT',0,0,0,0,1,0,1]
  ];

  var PRODUCTS = {
    'motocubby_t7_nomad':    [0],
    'motocubby_t7_nomad2':   [3],
    'motocubby_t7_nomad3':   [4],
    'motocubby_t7_scout':    [1, 2],
    'motocubby_t7_drifter':  [5],
    'motocubby_t7_drifter2': [6]
  };

  var PRODUCT_NAMES = {
    'motocubby_t7_nomad':    'Nomad',
    'motocubby_t7_nomad2':   'Nomad II',
    'motocubby_t7_nomad3':   'Nomad III',
    'motocubby_t7_scout':    'Scout',
    'motocubby_t7_drifter':  'Drifter',
    'motocubby_t7_drifter2': 'Drifter II'
  };

  var LS_KEY = 't7_bike_selection';
  var SHOP_URL = '/collections/tenere-700';
  var MARKET_LABEL = { US: 'N. America', EU: 'Europe', AU: 'Australia', JP: 'Japan' };
  var MARKET_FROM_RQ = { bt_america:'US', bt_canada:'US', bt_europe:'EU', bt_australia:'AU', bt_japan:'JP' };
  var _filtering = false;

  function getRow(year, market, variant) {
    var y = parseInt(year, 10);
    for (var i = 0; i < F.length; i++) {
      if (F[i][0] === variant && F[i][1] === market && F[i][2] === y) return F[i];
    }
    return null;
  }

  function fitStatus(handle, year, market, variant) {
    var row = getRow(year, market, variant);
    if (!row) return 'unknown';
    var cols = PRODUCTS[handle];
    if (!cols) return 'unknown';
    var hasUnknown = false;
    for (var i = 0; i < cols.length; i++) {
      var v = row[cols[i] + 5];
      if (v === 1) return 'fit';
      if (v === 2) hasUnknown = true;
    }
    return hasUnknown ? 'unknown' : 'no_fit';
  }

  // Best fit status for a product across ALL markets for a given year+variant
  function fitStatusAnyMarket(handle, year, variant) {
    var y = parseInt(year, 10);
    var cols = PRODUCTS[handle];
    if (!cols) return 'unknown';
    var best = 'no_fit';
    for (var i = 0; i < F.length; i++) {
      var r = F[i];
      if (r[0] === variant && r[2] === y) {
        for (var j = 0; j < cols.length; j++) {
          var v = r[cols[j] + 5];
          if (v === 1) return 'fit';
          if (v === 2 && best === 'no_fit') best = 'unknown';
        }
      }
    }
    return best;
  }

  // All handles that fit a given year+variant in any market
  function fittingHandles(year, variant) {
    var y = parseInt(year, 10);
    var result = [];
    Object.keys(PRODUCTS).forEach(function(h) {
      var cols = PRODUCTS[h];
      for (var i = 0; i < F.length; i++) {
        var r = F[i];
        if (r[0] === variant && r[2] === y) {
          for (var j = 0; j < cols.length; j++) {
            if (r[cols[j] + 5] === 1) { result.push(h); return; }
          }
        }
      }
    });
    return result;
  }

  function availableVariants(year, market) {
    var y = parseInt(year, 10);
    var seen = {}, out = [];
    for (var i = 0; i < F.length; i++) {
      var r = F[i];
      if (r[2] === y && r[1] === market && !seen[r[0]]) { seen[r[0]] = true; out.push(r[0]); }
    }
    return out;
  }

  // Valid years for a product across all markets (where any col = 1)
  function validYearsForHandle(handle) {
    var cols = PRODUCTS[handle];
    if (!cols) return [];
    var years = {};
    F.forEach(function(r) {
      cols.forEach(function(c) {
        if (r[c + 5] === 1 || r[c + 5] === 2) years[r[2]] = true;
      });
    });
    return Object.keys(years).map(Number).sort();
  }

  // Valid variants for a product in a given year across all markets
  function validVariantsForHandleYear(handle, year) {
    var cols = PRODUCTS[handle];
    if (!cols) return [];
    var y = parseInt(year, 10);
    var seen = {};
    F.forEach(function(r) {
      if (r[2] === y) {
        cols.forEach(function(c) {
          if ((r[c + 5] === 1 || r[c + 5] === 2) && !seen[r[0]]) seen[r[0]] = true;
        });
      }
    });
    return Object.keys(seen);
  }

  function load() { try { var r = localStorage.getItem(LS_KEY); return r ? JSON.parse(r) : null; } catch(e) { return null; } }
  function save(sel) { try { localStorage.setItem(LS_KEY, JSON.stringify(sel)); } catch(e) {} }
  function clearSel() { try { localStorage.removeItem(LS_KEY); } catch(e) {} }
  function isCollectionPage() { return location.pathname.indexOf('/collections/') === 0; }
  function $id(id) { return document.getElementById(id); }

  function populateVariants(selectEl, year, market, selectedVariant) {
    if (!selectEl) return;
    if (!year || !market) {
      selectEl.innerHTML = '<option value="">Pick year & region first</option>';
      selectEl.disabled = true; return;
    }
    var variants = availableVariants(year, market);
    if (!variants.length) {
      selectEl.innerHTML = '<option value="">No variants found</option>';
      selectEl.disabled = true; return;
    }
    selectEl.disabled = false;
    selectEl.innerHTML = '<option value="">Variant…</option>';
    variants.forEach(function(v) {
      var o = document.createElement('option');
      o.value = v; o.textContent = v;
      if (v === selectedVariant) o.selected = true;
      selectEl.appendChild(o);
    });
  }

  function setToggleLabel(sel) {
    var label = $id('t7-sel-label'), clearBtn = $id('t7-sel-clear');
    if (!label) return;
    if (sel && sel.year && sel.market && sel.variant) {
      label.textContent = sel.year + ' · ' + (MARKET_LABEL[sel.market] || sel.market) + ' · ' + sel.variant;
      label.classList.add('t7-active');
      if (clearBtn) clearBtn.removeAttribute('hidden');
    } else {
      label.textContent = 'Select year & variant →';
      label.classList.remove('t7-active');
      if (clearBtn) clearBtn.setAttribute('hidden', '');
    }
  }

  function updateCollStatus(sel) {
    var statusEl = $id('t7-coll-status'), clearBtn = $id('t7-coll-clear');
    if (!statusEl) return;
    if (sel && sel.year && sel.market && sel.variant) {
      var fitCount = 0;
      document.querySelectorAll('.product-grid .grid__item').forEach(function(item) {
        if (item.style.display !== 'none') fitCount++;
      });
      statusEl.textContent = 'Showing ' + fitCount + ' product' + (fitCount !== 1 ? 's' : '') +
        ' for your ' + sel.year + ' ' + (MARKET_LABEL[sel.market] || sel.market) + ' ' + sel.variant + '.';
      if (clearBtn) clearBtn.removeAttribute('hidden');
    } else {
      statusEl.textContent = 'Select your bike to filter products.';
      if (clearBtn) clearBtn && clearBtn.setAttribute('hidden', '');
    }
  }

  function filterProducts(sel) {
    if (_filtering) return;
    _filtering = true;
    try {
      document.querySelectorAll('.product-grid .grid__item').forEach(function(item) {
        var badge = item.querySelector('.t7-fit-badge');
        if (badge) badge.remove();
        if (!sel || !sel.year || !sel.market || !sel.variant) { item.style.display = ''; return; }
        var link = item.querySelector('a[href*="/products/"]');
        if (!link) { item.style.display = ''; return; }
        var m = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
        if (!m) { item.style.display = ''; return; }
        var status = fitStatus(m[1], sel.year, sel.market, sel.variant);
        if (status === 'no_fit') {
          item.style.display = 'none';
        } else {
          item.style.display = '';
          if (status === 'unknown') {
            var cw = item.querySelector('.card-wrapper');
            if (cw) {
              cw.style.position = 'relative';
              var b = document.createElement('span');
              b.className = 't7-fit-badge t7-fit-badge--unknown';
              b.textContent = 'Fitment unverified';
              cw.insertBefore(b, cw.firstChild);
            }
          }
        }
      });
    } finally { _filtering = false; }
  }

  function prefillForm(sel) {
    if (!sel) return;
    document.querySelectorAll('[data-t7-fitment="year"]').forEach(function(el) {
      if (!el.value && sel.year && el.querySelector('option[value="' + sel.year + '"]')) el.value = sel.year;
    });
    document.querySelectorAll('[data-t7-fitment="variant"]').forEach(function(el) {
      if (!el.value && sel.variant && el.querySelector('option[value="' + sel.variant + '"]')) el.value = sel.variant;
    });
  }

  function syncCollFinder(sel) {
    var cy = $id('t7-coll-year'), cm = $id('t7-coll-market'), cv = $id('t7-coll-variant');
    if (!cy) return;
    if (sel) {
      if (sel.year) cy.value = sel.year;
      if (sel.market) cm.value = sel.market;
      if (sel.year && sel.market) populateVariants(cv, sel.year, sel.market, sel.variant);
    } else {
      cy.value = ''; if (cm) cm.value = '';
      populateVariants(cv, '', '', null);
    }
  }

  function initHeaderBar(sel) {
    var bar = $id('t7-selector-bar');
    if (!bar) return;
    var toggleBtn = $id('t7-selector-toggle'), panel = $id('t7-selector-panel'),
        clearBtn = $id('t7-sel-clear'), yearEl = $id('t7-sel-year'),
        marketEl = $id('t7-sel-market'), variantEl = $id('t7-sel-variant'),
        applyBtn = $id('t7-sel-apply');
    if (sel) {
      if (yearEl && sel.year) yearEl.value = sel.year;
      if (marketEl && sel.market) marketEl.value = sel.market;
      if (sel.year && sel.market) populateVariants(variantEl, sel.year, sel.market, sel.variant);
    }
    setToggleLabel(sel);
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var open = toggleBtn.getAttribute('aria-expanded') === 'true';
        toggleBtn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      });
    }
    document.addEventListener('click', function(e) {
      if (!bar.contains(e.target)) {
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      }
    });
    function onYM() { populateVariants(variantEl, yearEl ? yearEl.value : '', marketEl ? marketEl.value : '', null); }
    if (yearEl) yearEl.addEventListener('change', onYM);
    if (marketEl) marketEl.addEventListener('change', onYM);
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var y = yearEl ? yearEl.value : '', m = marketEl ? marketEl.value : '', v = variantEl ? variantEl.value : '';
        var missing = false;
        [yearEl, marketEl].forEach(function(el) { if (el && !el.value) { el.style.borderColor = '#c9372c'; missing = true; } });
        if (variantEl && !variantEl.disabled && !variantEl.value) { variantEl.style.borderColor = '#c9372c'; missing = true; }
        if (missing) return;
        var newSel = { year: y, market: m, variant: v };
        save(newSel); setToggleLabel(newSel);
        [yearEl, marketEl, variantEl].forEach(function(el) { if (el) el.style.borderColor = ''; });
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
        if (isCollectionPage()) { filterProducts(newSel); updateCollStatus(newSel); syncCollFinder(newSel); }
        else { window.location.href = SHOP_URL; }
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        clearSel(); setToggleLabel(null); filterProducts(null); updateCollStatus(null);
        if (yearEl) yearEl.value = ''; if (marketEl) marketEl.value = '';
        populateVariants(variantEl, '', '', null); syncCollFinder(null);
      });
    }
  }

  function initCollFinder(initialSel) {
    var yearEl = $id('t7-coll-year'), marketEl = $id('t7-coll-market'),
        variantEl = $id('t7-coll-variant'), applyBtn = $id('t7-coll-apply'),
        clearBtn = $id('t7-coll-clear');
    if (!yearEl) return;
    var sel = initialSel;
    if (sel) {
      if (sel.year) yearEl.value = sel.year;
      if (sel.market) marketEl.value = sel.market;
      if (sel.year && sel.market) populateVariants(variantEl, sel.year, sel.market, sel.variant);
    }
    updateCollStatus(sel && sel.variant ? sel : null);
    function onYM() { populateVariants(variantEl, yearEl.value, marketEl.value, null); }
    yearEl.addEventListener('change', onYM);
    if (marketEl) marketEl.addEventListener('change', onYM);
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var y = yearEl.value, m = marketEl ? marketEl.value : '', v = variantEl ? variantEl.value : '';
        var missing = false;
        [yearEl, marketEl].forEach(function(el) { if (el && !el.value) { el.style.borderColor = '#c9372c'; missing = true; } });
        if (variantEl && !variantEl.disabled && !v) { variantEl.style.borderColor = '#c9372c'; missing = true; }
        if (missing) return;
        var newSel = { year: y, market: m, variant: v };
        save(newSel); sel = newSel;
        [yearEl, marketEl, variantEl].forEach(function(el) { if (el) el.style.borderColor = ''; });
        filterProducts(newSel); updateCollStatus(newSel); setToggleLabel(newSel);
        var hYear = $id('t7-sel-year'); if (hYear) hYear.value = y;
        var hMkt = $id('t7-sel-market'); if (hMkt) hMkt.value = m;
        populateVariants($id('t7-sel-variant'), y, m, v);
        var hClr = $id('t7-sel-clear'); if (hClr) hClr.removeAttribute('hidden');
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        clearSel(); sel = null;
        yearEl.value = ''; if (marketEl) marketEl.value = '';
        populateVariants(variantEl, '', '', null);
        filterProducts(null); updateCollStatus(null); setToggleLabel(null);
        var hYear = $id('t7-sel-year'); if (hYear) hYear.value = '';
        var hMkt = $id('t7-sel-market'); if (hMkt) hMkt.value = '';
        populateVariants($id('t7-sel-variant'), '', '', null);
        clearBtn.setAttribute('hidden', '');
      });
    }
    var grid = document.querySelector('.product-grid');
    if (grid) {
      new MutationObserver(function(muts) {
        if (_filtering) return;
        if (muts.some(function(mu) { return mu.addedNodes.length > 0; }) && sel && sel.variant) {
          filterProducts(sel); updateCollStatus(sel);
        }
      }).observe(grid, { childList: true, subtree: false });
    }
  }

  function init() {
    var sel = load();
    if (!sel) {
      try {
        var rq = new URLSearchParams(location.search).get('rq');
        if (rq) {
          var parts = rq.split('__');
          var yp = parts.find(function(p) { return p.slice(0,3) === 'yr_'; });
          var mp = parts.find(function(p) { return p.slice(0,3) === 'bt_'; });
          if (yp && mp && MARKET_FROM_RQ[mp]) sel = { year: yp.slice(3), market: MARKET_FROM_RQ[mp], variant: '' };
        }
      } catch(e) {}
    }
    initHeaderBar(sel);
    initCollFinder(sel);
    if (isCollectionPage()) {
      filterProducts(sel && sel.variant ? sel : null);
      updateCollStatus(sel && sel.variant ? sel : null);
    } else {
      prefillForm(sel);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Public API — exposed for buy-buttons fitment validation
  window.t7BikeSelector = {
    load: load, save: save,
    F: F, PRODUCTS: PRODUCTS, PRODUCT_NAMES: PRODUCT_NAMES,
    fitStatusAnyMarket: fitStatusAnyMarket,
    fittingHandles: fittingHandles,
    validYearsForHandle: validYearsForHandle,
    validVariantsForHandleYear: validVariantsForHandleYear
  };

})();
